export const getDayOffset = () => {
  const startDate = new Date(2022, 0, 1);
  const msOffset = Date.now() - startDate.getTime();
  return Math.floor(msOffset / 1000 / 60 / 60 / 24);
};
